import React, { useState, useEffect } from "react";

const SetsProductCardComponent = ({
  product,
  selectedProducts,
  setSelectedProducts,
  calculateItemsPrice,
  index,
  firstProductInitialized,
  setFirstProductInitialized,
  selectionWarning,
}) => {
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    if (index === 0 && !firstProductInitialized) {
      setSelectedProducts([{ ...product, purchasedQuantity: 1 }]);
      setQuantity(1);
      setFirstProductInitialized(true);
    }
  }, [
    index,
    firstProductInitialized,
    product,
    setSelectedProducts,
    setFirstProductInitialized,
  ]);

  const handleQuantityChange = (e) => {
    const value = Math.max(1, parseInt(e.target.value) || 1);
    setQuantity(value);

    setSelectedProducts((prevSelected) =>
      prevSelected.map((p) =>
        p._id === product._id ? { ...p, purchasedQuantity: value } : p
      )
    );
    calculateItemsPrice();
  };

  const isSelected = selectedProducts.some((item) => item._id === product._id);

  const toggleSelect = () => {
    if (isSelected) {
      const updated = selectedProducts.filter(
        (item) => item._id !== product._id
      );
      setSelectedProducts(updated);
      // 👇 Show warning if list becomes empty
      if (updated.length === 0) {
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: "smooth" }); // optional scroll to top
        }, 100);
      }
    } else {
      setSelectedProducts((prev) => [
        ...prev,
        { ...product, purchasedQuantity: quantity },
      ]);
    }
    calculateItemsPrice();
  };

  return (
    <div
      key={product._id}
      className={`relative w-[220px] bg-white border rounded-xl shadow-md p-4 transition duration-300 transform hover:scale-105 cursor-pointer ${
        selectionWarning
          ? "border-red-500 animate-pulse"
          : isSelected
          ? "border-green-600 bg-green-100 hover:shadow-xl"
          : "hover:border-blue-400 hover:bg-blue-100 hover:shadow-md"
      }`}
      onClick={toggleSelect}
    >
      <div className="relative animate-fade-in">
        <img
          src={product.img}
          alt={product.name}
          className="w-full h-64 object-cover rounded-lg mb-3"
        />
        {isSelected && (
          <div className="absolute top-2 left-2 bg-green-800 text-white text-xs px-2 py-1 rounded animate-pulse">
            تم اختياره
          </div>
        )}
      </div>

      <h4 className="text-sm font-semibold text-center text-gray-800 mb-1 whitespace-normal">
        {product.name}
      </h4>

      <p className="text-center text-gray-600 text-sm mb-2">
        <span className="font-bold">{product.price} دج</span>
      </p>

      {isSelected && (
        <div className="flex justify-center items-center mt-2 space-x-2 rtl:space-x-reverse">
          <button
            type="button"
            className="px-3 py-1 rounded bg-green-700 text-white hover:bg-green-800 transition"
            onClick={(e) => {
              e.stopPropagation();
              handleQuantityChange({ target: { value: quantity - 1 } });
            }}
          >
            -
          </button>
          <span className="px-3 text-lg font-medium">{quantity}</span>
          <button
            type="button"
            className="px-3 py-1 rounded bg-green-700 text-white hover:bg-green-800 transition"
            onClick={(e) => {
              e.stopPropagation();
              handleQuantityChange({ target: { value: quantity + 1 } });
            }}
          >
            +
          </button>
        </div>
      )}
    </div>
  );
};

export default SetsProductCardComponent;
